exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "i.homeAboutLogo {\n  float: left;\n  width: 90px;\n  height: 90px;\n  display: block;\n  margin-right: 25px;\n  background: url(" + require("../../assets/img/eti-gumus-logo.svg") + ") center center no-repeat; }\n\nh1 {\n  font-size: 28px;\n  color: #383E9A;\n  margin: 26px 0 50px; }\n\nh3 {\n  font-size: 22px;\n  color: #000447;\n  margin: 0 0 30px;\n  padding: 0 0 20px 10px;\n  border-bottom: 1px dashed #000447; }\n\ndiv.list-group a.list-group-item {\n  cursor: pointer;\n  background-color: #f7f7f7; }\n\ndiv.list-group a.active {\n  color: #ffffff;\n  background-color: #1b1c2c !important;\n  outline: none;\n  border: none; }\n\ndiv#evuTabsContainer {\n  position: relative; }\n  div#evuTabsContainer div.evuTabs {\n    left: 0;\n    top: 0;\n    width: 100%;\n    position: absolute; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/emrevolkanucar/Desktop/Angular/etigumus/src/app/process/process.component.scss
// module id = ../../../../../src/app/process/process.component.scss
// module chunks = main